import { render, staticRenderFns } from "./title-image-row.vue?vue&type=template&id=ca972164&"
import script from "./title-image-row.vue?vue&type=script&lang=js&"
export * from "./title-image-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports